import MainMenu from "./mainmenu";
import { Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import SideBar from "./SideBar";
export default function HeaderFour(){
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });           
    /* Method that will fix header after a specific scrollable */
	const isSticky = (e) => {
		const header = document.querySelector('.main-header-area');
		const scrollTop = window.scrollY;
		scrollTop >= 250 ? header.classList.add('sticky-menu') : header.classList.remove('sticky-menu');
	};
    const openSideBar = () =>{
		document.body.classList.add('on-side');		
	}
    return(
        <>
            <SideBar/>
            <div className="body-overlay activemode"></div>
            <header className="transparent-header4 home-4">
                <div className="main-header-area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-2 col-sm-4 col-4">
                                <div className="logo-area">
                                    <Link className="front" to="/"><img src="assets/img/home-4/logo-4.png" alt="Header-logo" /></Link>
                                    <Link className="back" to="/"><img src="assets/img/home-4/logo-4.png" alt="Header-logo" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-10 col-sm-8 col-8 text-end text-lg-start">
                                <div className="menu-style-3">       
                                    <div class="hamburger-menu d-md-inline-block d-lg-none text-left">								
                                        <a  onClick={openSideBar}><img src="assets/img/icon/eclips-1.png" alt="Eclips" /></a>
                                    </div>                   
                                <MainMenu/>
                                    <div className="right-content">
                                        <div className="query-list">
                                            <span className="sub-text">Call Us:</span>
                                            <a href="#" className="text-heading"> +02 334 0443</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>	
            </header>
        </>
       
    )
}